import { render, staticRenderFns } from "./AfterCourseOverview.vue?vue&type=template&id=4dd63492"
import script from "./AfterCourseOverview.vue?vue&type=script&lang=js"
export * from "./AfterCourseOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports